/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_EmailInputs */

const en_tables_custom_pages_email = /** @type {(inputs: Tables_Custom_Pages_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Email`)
};

const de_tables_custom_pages_email = /** @type {(inputs: Tables_Custom_Pages_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Pages Email" |
*
* @param {Tables_Custom_Pages_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_email = /** @type {((inputs?: Tables_Custom_Pages_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_email(inputs)
	return de_tables_custom_pages_email(inputs)
});